var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMentalhealth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.0286C7 13.4343 8.91636 11.2158 11.6298 10.3031C11.8297 7.89871 14.226 6 17.1538 6C18.1734 6 19 6.82655 19 7.84615L19 31.1538C19 32.1734 18.1734 33 17.1538 33C14.2263 33 11.8301 31.1017 11.6298 28.6976C8.91619 27.785 7 25.5658 7 22.9714C7 21.6842 7.47162 20.4891 8.27824 19.5C7.47162 18.5109 7 17.3158 7 16.0286Z",
    fill: "#FFCED8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.0286C33 13.4343 31.0836 11.2158 28.3702 10.3031C28.1703 7.89871 25.774 6 22.8462 6C21.8266 6 21 6.82655 21 7.84615L21 31.1538C21 32.1734 21.8266 33 22.8462 33C25.7737 33 28.1699 31.1017 28.3702 28.6976C31.0838 27.785 33 25.5658 33 22.9714C33 21.6842 32.5284 20.4891 31.7218 19.5C32.5284 18.5109 33 17.3158 33 16.0286Z",
    fill: "#FFAFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMentalhealth);
export default __webpack_public_path__ + "static/media/ic_mentalhealth.20f85c527b37e47757e0f5abb8989391.svg";
export { ForwardRef as ReactComponent };